import type { ComponentProps } from 'react';

/** A pending move blocks input without flashing otherwise available controls as unavailable. */
export function ClassroomControlButton({
  busy,
  disabled = false,
  className = '',
  ...props
}: ComponentProps<'button'> & { readonly busy: boolean }) {
  return (
    <button
      {...props}
      className={`${className}${busy && !disabled ? ' classroom-control-busy' : ''}`.trim()}
      disabled={disabled || busy}
      aria-busy={busy}
    />
  );
}
